import { render, staticRenderFns } from "./ItemCategory.vue?vue&type=template&id=554892d4&"
import script from "./ItemCategory.vue?vue&type=script&lang=ts&"
export * from "./ItemCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports